import React, { useMemo } from "react";
import { buildContractViewHtml, SAMPLE_CONTRACT_DATA } from "./contractView";

const ViewMode = ({ contentHtml }) => {
  const html = useMemo(
    () => buildContractViewHtml(contentHtml, SAMPLE_CONTRACT_DATA),
    [contentHtml]
  );
  return (
    <>
      <div
        className="contract-view-doc"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <div className="contract-view-note">
        The actual contract will be sent with real inspection data.
      </div>
    </>
  );
};

export default ViewMode;
